// === SAA:UTILS:REQUEST-STATE ===
// Is the aanvraag already sent, or on its way? Sent = the per relation+quote
// marker the confirmation screen writes on success (sessionStorage, survives
// navigation). In flight = the confirmation screen's submit call is running
// (module flag: set on submit, cleared on success/failure). The shell uses this
// to decide what a logo click does: keep the workflow state, reset it, or — while
// the submit is still running — do nothing at all.
import { getQuoteId, getVpIdnr, requestSubmittedKey } from '../pages/screens/summary/sessionState';

let requestInFlight = false;

export const setRequestInFlight = (inFlight: boolean): void => {
  requestInFlight = inFlight;
};

export const isRequestSent = (): boolean => {
  if (typeof sessionStorage === 'undefined') return false;
  const vpIdnr = getVpIdnr();
  const quoteId = getQuoteId();
  return !!(vpIdnr && quoteId && sessionStorage.getItem(requestSubmittedKey(vpIdnr, quoteId)) === 'true');
};

export const isRequestInFlight = (): boolean => requestInFlight;
